import { createStyles, IconButton, makeStyles } from "@material-ui/core";
import classnames from "classnames";
import * as React from "react";

import { FeedbackTypeEnum } from ".";
import { Button, RelodeTheme, ThumbsDownIcon, ThumbsUpIcon } from "../../";

const useStyles = makeStyles(
    (theme: RelodeTheme) =>
        createStyles({
            root: {
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                flexDirection: "column",
            },
            upButton: {
                width: "80px",
                marginRight: theme.spacing(1),
                opacity: 0.3,
                padding: "7px", // account for 1px border around button
                lineHeight: "normal",
            },
            downButton: {
                width: "80px",
                opacity: 0.3,
                padding: "7px", // account for 1px border around button
                lineHeight: "normal",
            },
            iconButton: {
                border: `1px solid ${theme.palette.primary.main}`,
                borderRadius: 24,
            },
            selectedButton: {
                opacity: "unset",
            },
            feedbackLabel: {
                textAlign: "center",
            },
        }),
    { name: "FeedbackButtons" }
);

interface FeedbackButtonsProps {
    onClick: (type: FeedbackTypeEnum) => void;
    selectedFeedbackType?: FeedbackTypeEnum;
    showFeedbackCounts?: boolean;
    upCount?: number;
    downCount?: number;
    className?: string;
}

export const FeedbackButtons = (props: FeedbackButtonsProps) => {
    const classes = useStyles(props);
    const {
        onClick,
        selectedFeedbackType,
        showFeedbackCounts,
        downCount,
        upCount,
        className,
    } = props;

    const upButtonClass = classnames(
        {
            [classes.iconButton]: !showFeedbackCounts,
            [classes.selectedButton]:
                selectedFeedbackType == FeedbackTypeEnum.Positive,
        },
        classes.upButton
    );

    const downButtonClass = classnames(
        {
            [classes.iconButton]: !showFeedbackCounts,
            [classes.selectedButton]:
                selectedFeedbackType == FeedbackTypeEnum.Negative,
        },
        classes.downButton
    );

    const rootClasses = classnames(classes.root, className);

    return showFeedbackCounts ? (
        <div className={rootClasses}>
            <div>
                <Button
                    startIcon={<ThumbsUpIcon />}
                    variant="outlined"
                    color="primary"
                    size="medium"
                    rounded={true}
                    className={upButtonClass}
                    onClick={() => onClick(FeedbackTypeEnum.Positive)}
                    data-cy="positiveFeedback"
                >
                    {upCount ? upCount : 0}
                </Button>
                <Button
                    startIcon={<ThumbsDownIcon />}
                    variant="outlined"
                    color="primary"
                    size="medium"
                    rounded={true}
                    className={downButtonClass}
                    onClick={() => onClick(FeedbackTypeEnum.Negative)}
                    data-cy="negativeFeedback"
                >
                    {downCount ? downCount : 0}
                </Button>
            </div>
        </div>
    ) : (
        <div className={rootClasses}>
            <div>
                <IconButton
                    color="primary"
                    size="medium"
                    className={upButtonClass}
                    onClick={() => onClick(FeedbackTypeEnum.Positive)}
                    data-cy="positiveFeedback"
                >
                    <ThumbsUpIcon />
                </IconButton>

                <IconButton
                    color="primary"
                    size="medium"
                    className={downButtonClass}
                    onClick={() => onClick(FeedbackTypeEnum.Negative)}
                    data-cy="negativeFeedback"
                >
                    <ThumbsDownIcon />
                </IconButton>
            </div>
        </div>
    );
};
